module.exports = __webpack_public_path__ + "static/media/session2.336ccf61.svg";